import { PickupSessionResponse } from '@apiContract';
import axios from 'axios';

export const getQrCode = async () => {
  return axios.get<PickupSessionResponse>('PickupSession');
};
